import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface paymentState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: paymentState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const paymentSlice = createSlice({
  name: ' payment',
  initialState,
  reducers: {
    setPayment: (state: any, action: any) => {
      state.data = action.payload;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewPayment: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setPayment, addNewPayment, reset } = paymentSlice.actions;
export const getPayment = (state: RootState) =>state.payment.data;
export const addPayment = (state: RootState) => state.payment.data;
export const getPaymentMethodTotalRecord = (state: RootState) => state.payment.totalRecords;

export default paymentSlice.reducer;
